module.exports = __webpack_public_path__ + "static/media/IMG_20191024_191155.a9059a75.jpg";